import { useGetOrg } from "@src/api/organizations/get-organization";
import { TRIAL_WELCOME_MODULES } from "@src/features/sharedExperience/components/alertsAndWarnings/moduleTrialWelcomeModules";
import {
  type LiveModuleTrial,
  useModuleTrials,
} from "@src/features/sharedExperience/hooks/use-module-trials";
import { useSelector } from "@src/store";
import { getIsAlertDismissed } from "@src/store/slices/appSettings";

export const welcomeAlertKey = (trial: LiveModuleTrial) =>
  `module-trial-welcome:${trial.stripePriceId}:${trial.startDate}`;

export const useModuleTrialWelcome = () => {
  const org = useGetOrg();
  const moduleTrials = useModuleTrials();

  const welcomeTrials = moduleTrials
    .filter((trial) => trial.moduleId in TRIAL_WELCOME_MODULES)
    .sort((a, b) => b.startDate - a.startDate);
  const newestTrial = welcomeTrials.at(0);
  const alertKey = newestTrial ? welcomeAlertKey(newestTrial) : "";

  const isDismissed = useSelector(
    getIsAlertDismissed(org.data?.org?.id, alertKey)
  );

  return {
    welcomeTrials,
    newestTrial,
    isPending: newestTrial !== undefined && !isDismissed,
  };
};
